/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode, useEffect, useState } from "react";
import Line from "rc-progress/es/Line";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

type StatusProps = {
  maxPercentage: number;
};

const Status = ({ maxPercentage }: StatusProps) => {
  const theme = useTheme();
  const [percentActualLineProgress, setPercentActualLineProgress] = useState(0);

  useEffect(() => {
    const increasePercentage = () => {
      if (percentActualLineProgress <= maxPercentage) {
        setPercentActualLineProgress(percentActualLineProgress + 1);
        return;
      }
      clearInterval(notificationInterval);
    };
    const notificationInterval = setInterval(increasePercentage, 20);
    return () => {
      clearInterval(notificationInterval);
    };
  }, [percentActualLineProgress]);

  return (
    <Box>
      <Line
        percent={percentActualLineProgress}
        strokeWidth={4}
        trailWidth={4}
        strokeColor={theme.palette.primary.main}
        strokeLinecap="square"
        style={{
          height: "12px",
          width: "100%",
          borderRadius: "0.5rem",
        }}
      />
    </Box>
  );
};

export default Status;
